export const isNegativeInteger = (value: number) => {
  return value < 0;
};
